<template>
    <div>
        <button
            :class="{'th-tooltip': withTooltip, '!th-btn-outline': outline}"
            class="th-btn th-btn-secondary flex" :data-tip="t('BatchSave')" @click="openDialog">
            <PtIcon class="th-btn-icon text-xl" icon="SolidSave" />
            <span>{{ t('BatchSave') }}</span>
        </button>
        <WorkSpaceDialog
            v-if="visible"
            :saveData="saveData"
        />
    </div>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import { PtIcon } from 'patsnap-biz';
import { cn, tw, en, jp } from './locales';
import '@patsnap-ui/icon/assets/solid/save.svg';
import { useI18n } from 'vue-i18n';
import type { IResultUrlNormalizedParameters } from '@eureka/services/src/types/results';
import { EBatchSaveType } from './types/batch-save';
import type { IBatchSaveProps } from './types/batch-save';
import WorkSpaceDialog from './components/WorkSpaceDialog.vue';
import { useDialog } from './composables/use-dialog';

const { t } = useI18n({
    messages: {
        cn, tw, en, jp,
    },
});
const props = withDefaults(defineProps<{
    result: IBatchSaveProps;
    conditions?: IResultUrlNormalizedParameters;
    type?: EBatchSaveType;
    withTooltip?: boolean;
    outline?: boolean;
}>(), {
    type: EBatchSaveType.PATENT,
    withTooltip: true,
    outline: false,
});

const saveData = computed(() => {
    return {
        ...props.result,
        conditions: props.conditions,
        type: props.type,
    }
})

const { visible, openDialog } = useDialog();
</script>
